import { render, staticRenderFns } from "./SuscripcionesPage.html?vue&type=template&id=2ced745b&external"
import script from "./SuscripcionesPage.vue?vue&type=script&lang=ts"
export * from "./SuscripcionesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports